import React, { createContext, useContext, useState } from "react";

/**
 * INTENT mapping — which Choghadiya slots empower which intent.
 * Choghadiya keys: amrit, shubh, labh, char, udveg, kaal, rog
 */
export const INTENTS = [
  { id: "all",     label: "all",     emoji: "✦", slots: ["amrit", "shubh", "labh", "char", "udveg", "kaal", "rog"], color: "#D8B97A", short: "everything" },
  { id: "money",   label: "money",   emoji: "❖", slots: ["amrit", "labh"],                                       color: "#D8B97A", short: "gain & wealth" },
  { id: "love",    label: "love",    emoji: "♡", slots: ["amrit", "shubh"],                                      color: "#D89BAA", short: "love & ceremony" },
  { id: "travel",  label: "travel",  emoji: "➤", slots: ["amrit", "char"],                                       color: "#6E9794", short: "motion & journey" },
  { id: "clarity", label: "clarity", emoji: "✧", slots: ["amrit", "shubh", "labh"],                              color: "#D8D6CC", short: "decisions & learning" },
];

const IntentCtx = createContext(null);

export function IntentProvider({ children }) {
  const [intent, setIntentState] = useState("all");
  const setIntent = (id) => {
    setIntentState(id);
    try { localStorage.setItem("thaigayu_intent", id); } catch { /* ignore */ }
  };
  // Hydrate from localStorage on mount
  React.useEffect(() => {
    try {
      const saved = localStorage.getItem("thaigayu_intent");
      if (saved && INTENTS.find((i) => i.id === saved)) setIntentState(saved);
    } catch { /* ignore */ }
  }, []);

  const current = INTENTS.find((i) => i.id === intent) || INTENTS[0];
  const matches = (slotKey) => current.slots.includes(slotKey);

  return (
    <IntentCtx.Provider value={{ intent, setIntent, current, matches }}>
      {children}
    </IntentCtx.Provider>
  );
}

export const useIntent = () => useContext(IntentCtx);
